import React from 'react';

const Logo = ({ altText = "Logo", width = 100, height = 100, margin = '0 auto' }) => {
    return (
        <img 
            src="/logo/HawkLogo.png"
            alt={altText} 
            width={width} 
            height={height} 
            style={{ display: 'block', margin: margin }}
        />
    );
};

export default Logo;
